// extracted by mini-css-extract-plugin
module.exports = {"locatorTile":"locator-tile_locatorTile__xDjuM","locatorOne":"locator-tile_locatorOne__AcBP7","withOverflow":"locator-tile_withOverflow__4wlR9"};